export default [

  '/api/irk-backend/'
  //  'http://localhost:8080/'
    ];
